<!-- PRIMEIRA LINHA -->
<div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill *ngIf="mostrarCampos">

    <!-- UNIDADE -->
    <div fxLayout="column" fxFlex="33%">
        <mat-toolbar class="titulopartes">Unidade</mat-toolbar>
        <mat-form-field>
            <mat-label>Unidade:</mat-label>
            <mat-select [(ngModel)]="planejamentoOficina.unidade.idUnidade" name="unidade" required>
                <mat-option></mat-option>
                <mat-option *ngFor="let u of unidades" [value]="u.idUnidade">
                    {{u.nomeUnidade}}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="unidades?.length === 0" align="start">Nenhuma unidade cadastrada</mat-hint>
        </mat-form-field>
    </div>


</div><!-- FIM PRIMEIRA LINHA -->





<!-- SEGUNDA LINHA -->
<div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <!-- NOME DA OFICINA -->
    <div fxLayout="column" fxFlex="60%">
        <mat-toolbar class="titulopartes">Nome da Oficina</mat-toolbar>
        <mat-form-field>
            <input #descricao matInput maxlength="200" name="descricao" placeholder="Nome da Oficina:"
                [(ngModel)]="planejamentoOficina.descricao" required>
            <mat-hint align="end">{{descricao.value.length}} / 200</mat-hint>
        </mat-form-field>
    </div>

    <!-- PERIODO DE EXECUCAO -->
    <div fxLayout="column" fxFlex="39%">
        <mat-toolbar class="titulopartes">Período de Execução</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="50px" fxFlexFill>
            <mat-form-field style="margin-left: 20px" fxFlex="40%">
                <input matInput name="dataInicioExecucao" [matDatepicker]="dataInicioExecucao" placeholder="Data de Início:"
                    [(ngModel)]="planejamentoOficina.dataInicio" (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataInicioExecucao"></mat-datepicker-toggle>
                <mat-datepicker #dataInicioExecucao></mat-datepicker>
            </mat-form-field>

            <mat-form-field fxFlex="40%">
                <input matInput name="dataFimExecucao" [matDatepicker]="dataFimExecucao" placeholder="Data Fim"
                    [(ngModel)]="planejamentoOficina.dataFim" (input)="onMascaraDataInput($event)">
                <mat-datepicker-toggle matSuffix [for]="dataFimExecucao"></mat-datepicker-toggle>
                <mat-datepicker #dataFimExecucao></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</div> <!-- FIM DA SEGUNDA LINHA -->

<!-- TERCEIRA LINHA -->
<div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxLayout="column" fxFlex="50%">
        <mat-toolbar class="titulopartes">Informações</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="25px" fxFlexFill>
                          
            <mat-form-field fxFlex="33%">
                <input [ngModelOptions]="{standalone: true}" 
                    matInput [textMask]="{mask: mascaraHorario}" placeholder="Carga Horária"
                    type="text" [ngModel]="planejamentoOficina.cargaHoraria | formatTimeHHMM"
                    (ngModelChange)="onTimeChange($event)">
            </mat-form-field>
              
            <mat-form-field fxFlex="33%">
                <input matInput type="number" name="quantidadeParticipantes" placeholder="Quantidade Participantes:"
                       [max]="999999" [(ngModel)]="planejamentoOficina.quantidadeParticipantes">
            </mat-form-field>

            <mat-form-field fxFlex="33%">
                <input matInput type="number" name="maximoParticipantes" placeholder="Máximo Participantes:"
                       [(ngModel)]="planejamentoOficina.maximoParticipantes">
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="column" fxFlex="50%">
        <mat-toolbar class="titulopartes">Percurso</mat-toolbar>
        <div fxLayout="row" fxLayoutGap="25px" fxFlexFill>
            <div ngModelGroup="comboContrato" fxLayoutGap="20px" fxFlex="100">
                <combo-percurso [showDisplayId]="false"
                                [obrigatorio]="false"
                                [selecionado]="planejamentoOficina.percurso"
                                (valorChange)="onValorChangePercurso($event)">
                </combo-percurso>
            </div>
        </div>
    </div>
</div><!-- FIM DA TERCEIRA LINHA -->

<!-- TERCEIRA LINHA -->
<!-- <div fxLayout="row" fxLayoutGap="30px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxLayout="column" fxFlex="50%">
        <div fxLayout="row" fxLayoutGap="25px" fxFlexFill>
            <mat-form-field style="margin: 0 0 0 20px" fxFlex="50%" appearance="outline">
                <mat-label>Público Alvo:</mat-label>
                <textarea #publicoAlvo matInput name="publicoAlvo" [(ngModel)]="planejamentoOficina.descricaoPublicoAlvo" cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="8" maxlength="200"></textarea>
                    <mat-hint align="end">{{publicoAlvo.value.length}} / 200</mat-hint>
            </mat-form-field>
        </div>
    </div>
</div> -->


<!-- QUARTA LINHA -->
<mat-toolbar class="titulopartes">Descrição</mat-toolbar>

<div fxLayout="row" fxLayoutGap="5%" style="margin-bottom: 20px">

    <mat-form-field class="topo" style="margin-left: 20px" fxFlex="100%" appearance="outline">
        <mat-label>Descrição:</mat-label>
        <textarea matInput #message name="metodologia" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3" maxlength="4000" [(ngModel)]="planejamentoOficina.descricaoMetodologia">
             </textarea>
        <mat-hint align="end">{{message.value.length}} / 4000</mat-hint>
    </mat-form-field>

</div><!-- FIM DA QUARTA LINHA -->



<!-- QUINTA LINHA -->
<mat-toolbar class="titulopartes">Horários</mat-toolbar>
<div fxLayout="row" 
     fxLayoutGap="50px" 
     style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
        <input matInput #horaInicio="ngModel" mat-hide-icons="calendar" type="time" name="horaInicio"
            placeholder="Hora Início:" [(ngModel)]="planejamentoOficina.horaInicio">
    </mat-form-field>

    <mat-form-field fxFlex="15%">
        <input matInput #horaFim="ngModel" mat-hide-icons="calendar" type="time" name="horaFim"
            placeholder="Hora Fim:" [(ngModel)]="planejamentoOficina.horaFim">
    </mat-form-field>
    
    <div fxLayout="row" fxFlex="80%" 
         fxLayoutAlign="start center" fxLayoutGap="10px" class="topo"
         fxFlexFill>
        <mat-slide-toggle name="segunda" [(ngModel)]="planejamentoOficina.segunda">SEG</mat-slide-toggle>
        <mat-slide-toggle name="terca" [(ngModel)]="planejamentoOficina.terca">TER</mat-slide-toggle>
        <mat-slide-toggle name="quarta" [(ngModel)]="planejamentoOficina.quarta">QUA</mat-slide-toggle>
        <mat-slide-toggle name="quinta" [(ngModel)]="planejamentoOficina.quinta">QUI</mat-slide-toggle>
        <mat-slide-toggle name="sexta" [(ngModel)]="planejamentoOficina.sexta">SEX</mat-slide-toggle>
        <mat-slide-toggle name="sabado" [(ngModel)]="planejamentoOficina.sabado">SAB</mat-slide-toggle>
        <mat-slide-toggle name="domingo" [(ngModel)]="planejamentoOficina.domingo">DOM</mat-slide-toggle>
    </div>

</div><!-- FIM QUINTA LINHA -->



<!-- DADOS BÁSICOS -->
<mat-toolbar class="titulopartes">Dados Básicos</mat-toolbar>
<div fxLayout="row" 
     fxLayoutAlign="space-between center" 
     style="margin-top: 10px; margin-bottom: 10px" 
     fxFlexFill>

            <!-- LOCAL EXECUÇÃO-->
            <mat-form-field fxFlex="30%" fxFlexOffset="20px">
                <mat-label>Local de Execução:</mat-label>
                <mat-select [(ngModel)]="planejamentoOficina.localExecucao" name="localExecucao">
                    <mat-option *ngFor="let u of localExecucao" [value]="u.id">
                        {{u.descricao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

</div>

<div fxLayout="row">
    <publico-alvo-planejamento-oficina fxFlexFill [planejamentoOficina]="planejamentoOficina"></publico-alvo-planejamento-oficina>
</div>